import {
	apiRequest
} from '../api.js'

// 获取基本信息
export function getBasicInfo(config) {
	config.method = 'post'
	config.url = '/adminapi/web/get-web-base-info'
	apiRequest(config)
}

// 获取友情链接
export function apirequest(config) {
	config.method = 'post'
	config.url = '/adminapi/web/get-web-link'
	apiRequest(config)
}

//发码平台发送验证码
export function sendSms(config) {
	config.method = 'post'
	config.url = '/adminapi/web/send-sms'
	apiRequest(config)
}

// 获取网站导航栏
export function getNavList(config){
	config.method = 'post'
	config.url = '/adminapi/web/get-web-nav'
	apiRequest(config)
}



// 获取申请注册申请表
export function getApplyinfo(config) {
	config.method = 'post'
	config.url = '/adminapi/login/view-sign'
	apiRequest(config)
}


export function getCompanyNames(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-company',
	apiRequest(config)

}

export function getTaxNumber(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-tax-num',
	apiRequest(config)


}

export function getClassTags(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-class-tags',
		apiRequest(config)


}


export function getPraticeList(config) {

	config.method = 'get'
	config.url = '/adminapi/pc/get-pratice-lists',
		apiRequest(config)


}

export function getQuesionList(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-question-list',
		apiRequest(config)


}


export function recordPractice(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/record-practice',
		apiRequest(config)


}

export function getTestRecord(config) {

	config.method = 'get'
	config.url = '/adminapi/pc/get-test-record',
		apiRequest(config)


}

export function getQuestionPractice(config) {

	config.method = 'get'
	config.url = '/adminapi/pc/get-question-practice',
		apiRequest(config)


}

export function getSpecialList(config) {

	config.method = 'get'
	config.url = '/adminapi/pc/get-special-list',
		apiRequest(config)


}


export function getTestQues(config) {

	config.method = 'get'
	config.url = '/adminapi/pc/get-test-ques',
		apiRequest(config)

}

export function getTestResult(config) {

	config.method = 'get'
	config.url = '/adminapi/pc/get-test-result',
		apiRequest(config)

}



export function getClassCate(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-class-cate',
		apiRequest(config)


}

export function collectQues(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/collect',
		apiRequest(config)


}

export function submitTest(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/submit-test',
		apiRequest(config)


}



export function getArticleCates(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-post-cates'
	apiRequest(config)


}


export function getClaDetail(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-cla-detail'
	apiRequest(config)


}


export function joinClass(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/join-class'
	apiRequest(config)


}

export function getUserInfo(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-userinfo'
	apiRequest(config)


}


export function getPractice(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-userinfo'
	apiRequest(config)


}




export function forgetPwd(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/forget-pwd'
	apiRequest(config)


}



export function editUserInfo(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/edit-userinfo'
	apiRequest(config)


}

export function recordVideo(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/record-video'
	apiRequest(config)


}


export function editPwd(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/edit-pwd'
	apiRequest(config)


}



export function getVideoList(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-video-list'
	apiRequest(config)


}


export function record_view_video(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/record_view_video'
	apiRequest(config)


}


export function getVideoSpeed(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-video-speed'
	apiRequest(config)


}


export function saveSpeed(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/save-speed'
	apiRequest(config)


}


export function changeStatus(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/change-record-status'
	apiRequest(config)


}


export function getMyClass(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-my-clas'
	apiRequest(config)


}

export function getMyOrders(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-orders'
	apiRequest(config)


}


export function getArticle(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-article'
	apiRequest(config)


}



export function getClaes(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/get-class-list',
		apiRequest(config)


}




export function register(config) {

	config.method = 'post'
	config.url = '/adminapi/pc/register',
		apiRequest(config)


}

export function Login(config) {
	config.method = 'post'
	config.url = '/adminapi/pc/login'
	apiRequest(config)
}




// 获取北建联图标logo
export function getIcon(config) {
	config.method = 'post'
	config.url = '/adminapi/web/get-web-base-info'
	apiRequest(config)
}

// 修改图标
export const changeFavicon = link => {
	let favicon = document.querySelector('link[rel="icon"]')
	if (favicon !== null) {
		favicon.href = link
	} else {
		favicon = document.createElement("link")
		favicon.rel = "icon"
		favicon.href = link
		document.head.appendChild(favicon)
	}
}
